export default __webpack_public_path__ + "media/titles/title_2_locale_en-903976ef.png";